import { Box, Typography } from '@mui/material';
import React from 'react';

import AccountSwitchToggle from './accountSwitchToggle';

import useAccountSwitcher from 'hooks/useAccountSwitcher';
import useTranslate from 'hooks/useTranslate';

const AccountSwitcher: React.FC = () => {
    const { translate } = useTranslate();
    const { accounts, canSwitch, selected } = useAccountSwitcher();

    if (!canSwitch || !selected || accounts.length < 2) {
        return null;
    }

    return (
        <Box sx={{ px: 1, pt: 1, pb: 0.75 }} aria-label={translate('switchAccount')}>
            <Typography
                sx={{
                    fontSize: 11,
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    letterSpacing: '0.08em',
                    color: 'text.disabled',
                    px: 1.25,
                    mb: 0.75,
                }}
            >
                {translate('switchAccount')}
            </Typography>
            <AccountSwitchToggle />
        </Box>
    );
};

export default AccountSwitcher;
